import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ManageStressLevels = lazyWithPreload(
  () => import('./ManageStressLevels'),
)
